import React from "react"
import avatar from "avatar/nuno.svg"

const Nuno = (props) => <img src={avatar} className="avatar" {...props} />

export default Nuno
